import { useState } from "react";
import Icon from "../components/Icon";
import { useConfirmar } from "../components/Confirmar";
import { puedeGestionarEquipos, puedeEditarEquipo, esAdmin, esSuper } from "../utils";
import { BtnPrimary, BtnGhost } from "../components/Atoms";
import { Avatar } from "../components/Atoms";

export default function TeamsPage({ teams, users, currentUser, card, setModal, removeTeamMember, onDeleteTeam }) {
  // Borrar equipos es del super; cambiar el nombre, el color y los miembros, tambien del admin de ESE equipo (lote S6).
  // El servidor rechaza a cualquier otro.
  const puedeGestionar = puedeGestionarEquipos(currentUser, teams);
  const [pedir, dialogo] = useConfirmar();
  // Listas largas (Promotores 15, Asesoras 14) plegadas tras los primeros miembros.
  const VISIBLES = 5;
  const [abiertos, setAbiertos] = useState(() => new Set());
  const alternar = id => setAbiertos(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  // Borrar un equipo quita a todos sus miembros de el y no se puede deshacer, asi que se
  // confirma DENTRO de la aplicacion (el dialogo del navegador no deja ver de que se habla) y
  // se dice a cuanta gente afecta.
  const borrar = async (team, miembros) => {
    const ok = await pedir({
      titulo: `¿Eliminar el equipo «${team.name}»?`, peligro: true, etiquetaOk: "Eliminar equipo",
      mensaje: "Se borra el equipo y deja de haber un grupo con ese nombre. Las personas siguen existiendo; solo salen de el.",
      detalle: miembros.length
        ? `${miembros.length} miembro${miembros.length === 1 ? "" : "s"}: ${miembros.map(u => u.name).join(", ")}`
        : "No tiene miembros.",
    });
    if (ok) onDeleteTeam(team.id);
  };

  return (
    <div style={{position:"relative",minHeight:"calc(100vh - 170px)"}}>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(290px,1fr))",gap:14}}>
      {teams.map((team) => {
        const mems = users.filter(u => (team.members||[]).includes(String(u.id)));
        const plegable = mems.length > VISIBLES + 1;
        const verTodos = abiertos.has(team.id);
        const mostrados = plegable && !verTodos ? mems.slice(0, VISIBLES) : mems;
        return (
          <div key={team.id} style={{...card, padding:18}}>
            <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:13}}>
              <div style={{width:36,height:36,borderRadius:10,background:team.color+"18",
                display:"flex",alignItems:"center",justifyContent:"center"}}>
                <Icon name={team.icon||"people-fill"} size={17} color={team.color}/>
              </div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,fontSize:14}}>{team.name}</div>
                <div style={{fontSize:11,color:"var(--text3)"}}>
                  {mems.length} miembro{mems.length!==1?"s":""}
                </div>
              </div>
              {puedeEditarEquipo(currentUser, team) && (
                <div style={{display:"flex",gap:5}}>
                  <BtnGhost onClick={()=>setModal({type:"editTeam",team})}
                    style={{padding:"4px 8px",fontSize:11}}>
                    <Icon name="pencil" size={11}/>Editar
                  </BtnGhost>
                  {puedeGestionar && <button aria-label={"Eliminar el equipo "+team.name} className="btn" onClick={()=>borrar(team, mems)}
                    title="Eliminar el equipo"
                    style={{minWidth:24,minHeight:24,alignItems:"center",justifyContent:"center",display:"inline-flex",padding:"4px 8px",borderRadius:7,border:"1px solid var(--border)",
                      cursor:"pointer",background:"transparent",color:"var(--text3)",
                      gap:4,fontSize:11,fontFamily:"var(--font)"}}>
                    <Icon name="trash3" size={11} color="var(--text3)"/>
                  </button>}
                </div>
              )}
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5}}>
              {mostrados.map(u => (
                <div key={u.id} title={u.email} style={{display:"flex",alignItems:"center",gap:8,
                  padding:"6px 9px",background:"var(--bg)",borderRadius:8,
                  border:"1px solid var(--border2)"}}>
                  <Avatar name={u.name} color={team.color} size={26}/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.name}</div>
                  </div>
                  {esAdmin(u) && (
                    <span style={{fontSize:10,padding:"2px 6px",borderRadius:20,
                      background:"var(--warn-bg)",color:"var(--warn-text)",fontWeight:700,flexShrink:0}}>{esSuper(u) ? "Super" : "Admin"}</span>
                  )}
                  {puedeEditarEquipo(currentUser, team) && String(u.id) !== String(currentUser?.id) && (
                    <button aria-label={"Quitar a "+u.name+" del equipo"} className="btn" onClick={()=>removeTeamMember(team.id, u.id)}
                      style={{minWidth:24,minHeight:24,alignItems:"center",justifyContent:"center",display:"inline-flex",background:"none",border:"none",cursor:"pointer",
                        color:"var(--text3)",padding:0,display:"flex",lineHeight:1}}>
                      <Icon name="x-lg" size={11} color="var(--text3)"/>
                    </button>
                  )}
                </div>
              ))}
              {plegable && (
                <button className="btn" onClick={()=>alternar(team.id)} aria-expanded={verTodos}
                  style={{alignSelf:"flex-start",background:"none",border:"none",cursor:"pointer",padding:"4px 2px",
                    fontSize:11.5,fontWeight:600,color:"var(--accent)",fontFamily:"var(--font)"}}>
                  {verTodos ? "Ver menos" : `Ver los ${mems.length}`}
                </button>
              )}
            </div>

            {puedeEditarEquipo(currentUser, team) && (
              <button className="btn" onClick={()=>setModal({type:"modifyMembers",team})}
                style={{marginTop:10,width:"100%",padding:"6px",
                  border:"1.5px dashed var(--border)",borderRadius:8,cursor:"pointer",
                  fontSize:11.5,color:"var(--text3)",background:"transparent",
                  fontFamily:"var(--font)",display:"flex",alignItems:"center",
                  justifyContent:"center",gap:5}}>
                <Icon name="person-plus-fill" size={12} color="var(--text3)"/>Modificar miembros
              </button>
            )}
          </div>
        );
      })}
      {teams.length === 0 && (
        <div style={{gridColumn:"1/-1",textAlign:"center",padding:"40px 0",color:"var(--text3)",fontSize:13}}>
          No hay equipos creados todavía
        </div>
      )}
    </div>
    {dialogo}
    </div>
  );
}
